import { render } from "./MediaForm.vue?vue&type=template&id=f8174d82"
import script from "./MediaForm.vue?vue&type=script&lang=js"
export * from "./MediaForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__